export const DUMMY_USER_ID = 101;
export const rentData = [
    {
        id: 1,
        name: 'JP Decks',
        price: '6500',
        image: 'https://img.squareyards.com/secondaryPortal/637966091935107378-2008220419531953.jpg?d=450x450',
        specification: {
            bed: 2,
            bathrooms: 2,
            area: 845,
        },
        road: 'Indira nagar',
        city: 'Bengaluru',
        country: 'INDIA',
        favourites: [],
        availablity: '2022-12-01',
        houseType: 'flat'
    },
    {
        id: 2,
        name: 'Aly-Moore',
        price: '55000',
        image: 'https://img.squareyards.com/secondaryPortal/637952424621949981-040822084102412.jpg',
        specification: {
            bed: 2,
            bathrooms: 1,
            area: 640,
        },
        road: 'Bandra East',
        city: 'Mumbai',
        country: 'INDIA',
        favourites: [],
        availablity: '2022-09-01',
        houseType: 'flat'
    },
    {
        id: 3,
        name: 'Brīsta',
        price: '14999',
        image: 'https://images.timesproperty.com/blog/2090/unnamed_86.jpg',
        specification: {
            bed: 2,
            bathrooms: 1,
            area: 640,
        },
        road: 'Pradhan Nagar',
        city: 'Siliguri',
        country: 'INDIA',
        favourites: [],
        availablity: '2023-01-01',
        houseType: 'house'
    },
    {
        id: 7,
        name: 'Himalaya Kanya',
        price: '8500',
        image: 'https://static.asianpaints.com/content/dam/beautifulhomes/images/living/homes/jasleen-singhs-1000-sqft-contemporary-indian-apartment-in-new-delhi/OYS_7252-2.jpg',
        specification: {
            bed: 2,
            bathrooms: 2,
            area: 1010,
        },
        road: 'Darjeeling Cross',
        city: 'Siliguri',
        country: 'INDIA',
        favourites: [],
        availablity: '2022-10-01',
        houseType: 'flat'
    },
    {
        id: 6,
        name: 'S. Ram',
        price: '25000',
        image: 'https://assets.architecturaldigest.in/photos/61de9b8d0f339dca4bd2963f/16:9/w_2560%2Cc_limit/Manipal%2520home.jpg',
        specification: {
            bed: 3,
            bathrooms: 2,
            area: 1550,
        },
        road: 'HSR Layout',
        city: 'Bengaluru',
        country: 'INDIA',
        favourites: [],
        availablity: '2022-06-22',
        houseType: 'bungalow'
    },
    {
        id: 8,
        name: 'Xavier Heights',
        price: '80000',
        image: 'https://i.ytimg.com/vi/eTt7AGIpV2I/maxresdefault.jpg',
        specification: {
            bed: 1,
            bathrooms: 1,
            area: 400,
        },
        road: 'Sealine',
        city: 'Mumbai',
        country: 'INDIA',
        favourites: [],
        availablity: '2022-11-01',
        houseType: 'flat'
    },
    {
        id: 4,
        name: 'Tānkā',
        price: '3500',
        image: 'https://psgroup.in/blog/wp-content/uploads/2020/11/luxury-flats-in-kolkata.jpeg',
        specification: {
            bed: 1,
            bathrooms: 1,
            area: 440,
        },
        road: 'JPR block',
        city: 'Pune',
        country: 'INDIA',
        favourites: [],
        availablity: '2022-11-02',
        houseType: 'flat'
    },
    {
        id: 5,
        name: 'Maitri',
        price: '13000',
        image: 'https://thearchitectsdiary.com/wp-content/uploads/2017/12/3-room-flat-interior-design_Livingroom.jpg',
        specification: {
            bed: 3,
            bathrooms: 2,
            area: 1300,
        },
        road: 'Vengadubi',
        city: 'Pune',
        country: 'INDIA',
        favourites: [],
        availablity: '2022-10-01',
        houseType: 'house'
    },
   
]